(ns dashboard.views.analysis.structured-analysis.view-structured-analysis-modal
  (:require ["react" :as react]
            [clojure.string :as str]
            [dashboard.entity.analysis.db :as analysis.db]
            [dashboard.entity.analysis.profile :as analysis.profile]
            [dashboard.subs :as common-subs]
            [dashboard.ui :as ui]
            [dashboard.views.analysis.structured-analysis.record-structured-analysis-modal :as record]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::analysis-versions
 (fn [db [_ construct-id]]
   (get-in db [:structured-analyses :data construct-id])))

(defn view-structured-analysis [{:keys [construct-id version-id]}]
  (let [{:keys [parent-id next-version-id version-id states categories relates-to excludes comment]
         :as this-analysis} @(analysis.db/structured-analysis* construct-id version-id)
        all-versions @(rf/subscribe [::analysis-versions construct-id])

        parent-analysis @(analysis.db/structured-analysis* parent-id)
        sub-analyses @(analysis.db/sub-analyses* construct-id)]
    [:div.column
     (when next-version-id
       (let [{:keys [construct-version
                     version-id
                     construct]} @(analysis.db/structured-analysis*
                                   construct-id
                                   next-version-id)]
         [:div.box.has-background-danger.has-text-white
          [:h6.title.is-6.mb-2.has-text-white "Analysis is superseded by"]
          [:div.level
           [:div.level-left
            [:span (str "v" construct-version " ") construct]]
           [:div.level-right
            [analysis.profile/view-button
             #(rf/dispatch [::show-view-modal construct-id version-id])
             "is-white"
             (str "v" construct-version)]]]]))

     [analysis.profile/field "Comment" [:span comment]]

     (when (seq categories) [analysis.profile/categories-view categories])

     [analysis.profile/field
      "States"
      [:<> (map (fn [state]
                  #^{:key (str "state-" (first state))}
                    [:span.mr-2
                     [analysis.profile/state-tag state]])
                states)]]

     (when parent-analysis
       [:f> analysis.profile/parent-dependencies-view
        parent-analysis
        this-analysis
        #(rf/dispatch [::show-view-modal (:id parent-analysis) nil])])

     (when (seq sub-analyses)
       [:f> analysis.profile/child-dependencies-view
        sub-analyses
        states
        #(rf/dispatch [::show-view-modal % nil])])

     (when (seq relates-to)
       [analysis.profile/field "Analysis relates to" (str/join ", " relates-to)])

     (when (seq excludes)
       [analysis.profile/field "Analysis excludes" (str/join ", " excludes)])

     ;; TODO: Show linked questions

     [:f> analysis.profile/expandable-hierarchy-table
      construct-id
      nil
      (constantly nil)
      (fn [{:keys [construct-id]}]
        (rf/dispatch [::show-view-modal construct-id nil]))
      #(analysis.db/hierarchy* %)]

     [:f> analysis.profile/version-history
      all-versions
      version-id
      #(rf/dispatch [::show-view-modal construct-id (:version-id %)])]]))

(defn view-structured-analysis-modal [{:keys [on-close ctx]}]
  (let [{:keys [construct-id version-id editing?]} ctx
        {:keys [next-version-id
                construct
                construct-version]
         :as analysis} @(analysis.db/structured-analysis* construct-id version-id)
        structured-analysis-creation-enabled? @(rf/subscribe [::common-subs/feature-enabled :structured-analysis-creation])]
    [:div.card.is-flex.is-flex-direction-column.p-4.is-align-items-flex
     [:div.card-header.has-background-white.is-shadowless
      [analysis.profile/structure-card-header-title construct-id construct construct-version]
      [:button.card-header-icon.is-align-self-flex-start {:on-click on-close}
       [:span.icon [:i.fas.fa-xmark]]]]
     [:div.card-content.p-0 {:style {:max-height "75vh" :overflow-y "scroll"}}
      [:div.is-flex {:style {:width "100%" :height "100%" :overflow-y "scroll"}}
       [:f> view-structured-analysis {:construct-id construct-id
                                      :version-id version-id}]]]
     (when structured-analysis-creation-enabled?
       [:footer.card-footer
        [:div.card-footer-item
         [:button.button.is-info.is-rounded {:title (cond
                                                      editing? "Already editing some analysis"
                                                      (some? next-version-id) "Cannot edit outdated analysis"
                                                      :else "Edit this analysis")
                                             :disabled (or editing?
                                                           (some? next-version-id))
                                             :on-click (fn [_]
                                                         (let [{:keys [relates-to excludes]} analysis]
                                                           (rf/dispatch [::record/show-record-modal (cond-> analysis
                                                                                                      ;; TODO: Why do we empty these attributes?
                                                                                                      (empty? relates-to) (assoc :relates-to [""])
                                                                                                      (empty? excludes) (assoc :excludes [""]))])))}
          "Edit structured analysis"]]])]))

(rf/reg-event-fx
  ::show-view-modal
  (fn [{:keys [db]} [_ construct-id version-id]]
    (let [editing? (some? (get-in db [record/-component-id :data]))]
      {:dispatch [::ui/push-modal {:component #'view-structured-analysis-modal
                                   :ctx {:construct-id construct-id
                                         :version-id version-id
                                         :editing? editing?}
                                   :content-props {:style {:min-width "75vw" :max-height "90vh" :padding 0}}}]})))

